<script>
export default {
  props: {
    stop: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <div class="spinner-snake" :style="stop ? 'animation-play-state: paused;' : ''"></div>
</template>

<style lang="stylus">
.spinner-snake
  width 28px
  height 28px
  border-top 4px solid $primary-color
  border-left 4px solid $primary-color
  border-right 4px solid $primary-color
  border-bottom 4px solid transparent
  border-radius 50%
  animation roll-snake infinite 0.8s linear

@keyframes roll-snake
  from
    transform rotate(0)
  to
    transform rotate(1turn)
</style>
